import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGoogleAnalytics, trackAnalyticsPageView } from "@/lib/analytics";

/**
 * Sends GA4 page_view on SPA navigations only (no chat, PII, or URL secrets).
 */
export function PageAnalytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    initGoogleAnalytics();
  }, []);

  useEffect(() => {
    trackAnalyticsPageView(pathname);
  }, [pathname]);

  return null;
}
